<template>
  <div
    class="intersector"
    ref="observerElement"
    :class="clsx({
      'intersector--active': isIntersecting,
      'intersector--disabled': !animationEnabled,
      [activeClass]: isIntersecting,
      [onceClass]: hasBeenIntersected
    })"
    @animationend="handleAnimationEnd"
  >
    <slot />
  </div>
</template>

<script>
import clsx from 'clsx';

export default {
  props: {
    animationEnabled: {
      type: Boolean,
      default: true,
    },
    activeClass: {
      type: String,
      default: 'active',
    },
    onceClass: {
      type: String,
      default: 'visible'
    },
    rootMargin: {
      type: String,
      default: '0px'
    },
    threshold: {
      type: [Number, Array],
      default: 0.01
    },
    once: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isIntersecting: false,
      hasBeenIntersected: false,
      observer: null
    };
  },
  mounted() {
    if (this.animationEnabled) {
      this.initializeObserver();
    }
  },
  beforeDestroy() {
    this.disconnectObserver();
  },
  watch: {
    animationEnabled(newValue) {
      if (newValue) {
        this.initializeObserver();
      } else {
        this.disconnectObserver();
      }
    }
  },
  methods: {
    clsx,
    initializeObserver() {
      if (!this.animationEnabled) return;

      const options = {
        root: null,
        rootMargin: this.rootMargin,
        threshold: this.threshold
      };

      this.observer = new IntersectionObserver(this.handleIntersect, options);

      if (this.$refs.observerElement) {
        this.observer.observe(this.$refs.observerElement);
      }
    },
    handleIntersect(entries) {
      entries.forEach(entry => {
        this.isIntersecting = entry.isIntersecting;

        if (entry.isIntersecting) {
          this.hasBeenIntersected = true;

          if (this.once) {
            this.disconnectObserver();
          }
        }
      });
    },
    handleAnimationEnd() {
      this.$emit('animation-end');
    },
    disconnectObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    },
    restartObservation() {
      this.disconnectObserver();
      this.hasBeenIntersected = false;
      this.isIntersecting = false;
      if (this.animationEnabled) {
        this.initializeObserver();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.intersector {
  opacity: 0;

  &--active {
    opacity: 1;
  }

  &--disabled {
    opacity: 1;
  }
}
</style>
